import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useTask } from 'lib/hooks/queries/tasks/useTask';

import PreviewTask from './PreviewTask';

const ViewTask = () => {
  const { id: taskId } = useParams();
  const navigate = useNavigate();
  const handleClose = () => navigate('..');

  const { data } = useTask({ params: { taskId } });
  const task = data?.task;

  if (!task) return;

  return <PreviewTask task={task} previewTaskModal hidePreviewTaskModal={handleClose} />;
};

export default ViewTask;
